import { format } from 'date-fns';
import { currencySymbol } from '/config';

const trimZero = (value) => value.toFixed(1).replace(/\.0$/, '');

// Compact money: 1.2M / 12.3K / 123, prefixed with the configured symbol.
export const formatCurrency = (value) => {
  const amount = Number(value) || 0;
  const abs = Math.abs(amount);
  let text;
  if (abs >= 1e6) text = `${trimZero(amount / 1e6)}M`;
  else if (abs >= 1e3) text = `${trimZero(amount / 1e3)}K`;
  else text = `${Math.round(amount)}`;
  return `${currencySymbol}${text}`;
};

export const formatNumber = (value) => new Intl.NumberFormat().format(Number(value) || 0);

export const formatPercent = (value, digits = 0) => `${(Number(value) || 0).toFixed(digits)}%`;

// Accepts ISO strings, Date objects and Arrow-returned epoch numbers.
export const formatDate = (value, pattern = 'dd MMM yyyy') => {
  if (value === null || value === undefined || value === '') return '';
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return format(date, pattern);
};

export const toNumberOrNull = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};
